;(function () {
  console.log('Cart listener loaded');

  const CART_ROUTES = [
    '/cart/add',
    '/cart/change',
    '/cart/update',
    '/cart/clear'
  ];

  function isCartRequest(url) {
    return CART_ROUTES.some(route => url.includes(route));
  }

  async function logCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      console.log('Cart items count:', cart.item_count);
      const indicator = document.querySelector('.cart-indicator');
      indicator.setAttribute('attr-cart-no',cart.item_count);
    } catch (e) {
      console.error('Failed to fetch cart:', e);
    }
  }

  /* ---- FETCH ---- */
  const originalFetch = window.fetch;
  window.fetch = function () {
    const args = arguments;

    return originalFetch.apply(this, args).then(function (response) {
      const url = args[0];

      if (typeof url === 'string' && isCartRequest(url)) {
        // Small delay ensures cart is updated before fetching
        setTimeout(logCartCount, 150);
      }

      return response;
    });
  };

  /* ---- XHR ---- */
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartRequest(url)) {
      this.addEventListener('load', function () {
        setTimeout(logCartCount, 150);
      });
    }
    return originalOpen.apply(this, arguments);
  };

})();
